import { Controller } from '@hotwired/stimulus';
import logger from 'src/analytics/logger';

let autoStart = false;
let mediaRepeat = false;
let mediaControls = true;

export default class MediaPlayerController extends Controller {
  static values = {
    playerId: String,
    mediaUrl: String,
    previewImage: String,
    autoStart: autoStart || String,
    mediaRepeat: mediaRepeat || Boolean,
    mediaControls: mediaControls || Boolean
  };

  initialize() {
    this.element[this.identifier] = this;
    this.playButtonClicked = false;
  }

  connect() {
    this.createPlayer();
  }

  createPlayer() {
    /* eslint-disable no-undef */
    // this is coming in from the main application. Need to assume it exists for now.
    this.player = jwplayer(this.playerIdValue);
    /* eslint-enable no-undef */

    this.player.setup({
      file: this.mediaUrlValue,
      image: this.previewImageValue,
      aspectratio: '16:9',
      autostart: this.autoStartValue,
      repeat: this.mediaRepeatValue,
      playbackRateControls: true,
      horizontalVolumeSlider: true,
      cast: {},
      controls: this.mediaControlsValue
    });
    this.player.on('play', this.handlePlay.bind(this));
  }

  handlePlay(event) {
    if (this.playButtonClicked) {
      return;
    }
    if (event.playReason !== 'interaction') {
      return;
    }

    logger.trackElementClicked({
      elementId: this.playerIdValue,
      label: 'Play'
    });
    this.playButtonClicked = true;
  }
}
